import isEmpty from 'lodash/isEmpty';

import styles from './NutritionDetails.module.scss';

export default function NutritionDetails({ productDetails }) {
  if (isEmpty(productDetails?.nutritionItems)) return null;

  return (
    <div className={styles.productDesciption}>
      <table>
        <thead>
          <tr>
            <th className={styles.desciptionTitle}>Διατροφικά Στοιχεία</th>
            <th className={styles.desciptionTitle}>
              {productDetails.nutritionUom ? `(ανά ${productDetails.nutritionUom})` : ''}
            </th>
            {productDetails.nutritionPack && (
              <th className={styles.desciptionTitle}>(ανά {productDetails.nutritionPack})</th>
            )}
            {(productDetails.nutritionPackReferenceIntakeQuota || productDetails.nutritionUomReferenceIntakeQuota) && (
              <th className={styles.desciptionTitle}>Ε.Η.Π</th>
            )}
          </tr>
        </thead>
        <tbody>
          {productDetails.nutritionItems.map(item => (
            <tr key={item._id}>
              <td className={styles.nutrionItemText}>{item.title}</td>
              <td className={styles.nutrionItemText}>{item.perUom}</td>
              {productDetails.nutritionPack && <td className={styles.nutrionItemText}>{item.perPack}</td>}
              {(productDetails.nutritionPackReferenceIntakeQuota ||
                productDetails.nutritionUomReferenceIntakeQuota) && (
                <td className={styles.nutrionItemText}>
                  {item.perUomReferenceIntakeQuota || item.perPackReferenceIntakeQuota || '-'}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
